import script from "./Services.vue?vue&type=script&setup=true&lang=js"
export * from "./Services.vue?vue&type=script&setup=true&lang=js"

import "./Services.vue?vue&type=style&index=0&id=68554549&lang=scss"

const __exports__ = script;

export default __exports__